import { DirectLinkStatus } from '@src/domains/direct-links';
import { OrderStatus } from '@src/domains/orders';
import { SaleChangeStatusEnum, SaleState } from '@src/domains/sales';
import type { Transactable } from '@src/domains/transactables/types/transactable';

// A sale change is its own charge riding on an order: the order underneath can be confirmed from the
// original purchase while the change itself was never paid, so the order's status answers nothing
// here. isTransactablePayable already gives the sale change the same precedence.
export const isTransactablePaymentComplete = (tr: Transactable): boolean => {
  if (tr.saleChange) {
    return tr.saleChange.status === SaleChangeStatusEnum.Applied;
  }

  return (
    tr.order?.status === OrderStatus.Confirmed ||
    tr.sale?.state === SaleState.PaymentComplete ||
    tr.directLink?.status === DirectLinkStatus.PaymentComplete
  );
};
